// extracted by mini-css-extract-plugin
module.exports = {"toggleSwitchWrapper":"ToggleSwitch_toggleSwitchWrapper__3w5jl","toggleSwitch":"ToggleSwitch_toggleSwitch__agN-c","slider":"ToggleSwitch_slider__mFYOG"};